import { render } from "./Psychotypes.vue?vue&type=template&id=6ef8bac8"
import script from "./Psychotypes.vue?vue&type=script&lang=js"
export * from "./Psychotypes.vue?vue&type=script&lang=js"

import "./Psychotypes.vue?vue&type=style&index=0&id=6ef8bac8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__